export default __webpack_public_path__ + "static/media/apco_logo.73ae5c12.png";